import AbstractCommand from "../../../core/application/AbstractCommand";
import LaptopDestroyEvent from "../model/LaptopDestroyEvent";
import LaptopSkinKeyRegistry from "../model/LaptopSkinKeyRegistry";

export default class LaptopSetupCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        this._laptopSkin = this.openPopup(LaptopSkinKeyRegistry.LAPTOP_MEDIATOR, null, { priority: 1, needsOverlay: false });

        this._destroyLaptopBound = this._destroyLaptop.bind(this);
        this._dispatcher.addEventListener(LaptopDestroyEvent.PERFORM, this._destroyLaptopBound);
    }

    destroy() {
        this._dispatcher.removeEventListener(LaptopDestroyEvent.PERFORM, this._destroyLaptopBound);
    }

    _destroyLaptop() {
        this.closePopup(this._laptopSkin);

        this.destroy();
    }
}